import { Injectable } from '@angular/core';
import { Layer } from './layer';

@Injectable({
  providedIn: 'root'
})
export class LayerHistoryService {
  private snapshots: Layer[][] = [];
  private currentLayer: number = -1;
  private lsItemName = 'layersHistory';
  constructor() {
    if (localStorage.getItem(this.lsItemName) === null) {
      this.snapshots = [];
    } else {
      this.snapshots = JSON.parse(localStorage.getItem(this.lsItemName));
    }
  }

  private save() {
    localStorage.setItem(this.lsItemName, JSON.stringify(this.snapshots));
  }

  getHistoryLength(): number {
    return this.currentLayer + 1;
  }

  getCurrentSnapshot(): Layer[] {
    if (this.snapshots.length == 0 || this.currentLayer == -1) {
      return [];
    }
    return JSON.parse(JSON.stringify(this.snapshots[this.currentLayer]));
  }

  goBack() {
    if (this.currentLayer >= 0) {
      this.currentLayer--;
    }
  }

  goForward() {
    if (this.currentLayer < this.snapshots.length - 1) {
      this.currentLayer++;
    }
  }

  clear(toSnapshot: number = 0) {
    this.snapshots = this.snapshots.slice(0, toSnapshot);
    this.currentLayer = toSnapshot - 1;
    this.save();
  }

  addSnapshot(layer: Layer[]) {
    if (this.snapshots.length > this.currentLayer + 1) {
      this.snapshots.splice(this.currentLayer + 1, this.snapshots.length);
    }
    this.currentLayer++;
    this.snapshots.push(layer);
    this.save();
  }

}
